//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../components/Table/Table.vue'
import StockInventoryRegradingRecord from './StockInventoryRegradingRecord.vue'
import { formatFieldDiffAmount, formatUniqueToolName } from './stockInventoryTools.js'
import ReportMaterialsImageBtn from '../Report/ReportMaterials/ReportMaterialsImageBtn.vue'

export default {
  components: {
    Table,
    ReportMaterialsImageBtn
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    toolRecord: {
      type: Object,
      default: null
    },
    regradingRecords: {
      type: Array,
      default: null
    },
    toolRecords: {
      type: Array,
      default: null
    },
    additionalAccessAdd: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 0,
        page: 1,
        sortBy: 'id',
        descending: true
      }
    }
  },
  computed: {
    requestProperties: function () {
      return this.record.requestProperties
    },
    propertyConfig: function () {
      return this.record.requestProperties.toolRecords
    },
    filteredRegradingRecords: function () {
      let filteredRegradingRecords = this.regradingRecords && this.regradingRecords.filter(r => !r.removed) || []
      if (this.toolRecord) {
        filteredRegradingRecords = filteredRegradingRecords.filter(r => r.toolARecordId === this.toolRecord.id || r.toolBRecordId === this.toolRecord.id)
      }

      return filteredRegradingRecords
    },
    readonly: function () {
      return !this.toolRecord
    },
    accessEdit: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable && this.additionalAccessAdd
    },
    accessAdd: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable && !this.readonly && this.additionalAccessAdd
    },
    accessDelete: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable && !this.readonly
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    columns: function () {
      return this.getColumns()
    },
    uniqueToolWithOneRegradingRecord: function () {
      return this.toolRecord.tool && (this.toolRecord.tool.serialNumber || this.toolRecord.tool.inventoryNumber) && this.filteredRegradingRecords.length >= 1
    }
  },
  methods: {
    validate: function () {
      // TODO
    },
    onOpen: function (regradingRecord) {
      let toolRecord = this.toolRecords.find(toolRecord => toolRecord.id === regradingRecord.toolARecordId)
      if (toolRecord) {
        toolRecord = JSON.parse(JSON.stringify(toolRecord))
      }

      const dialog = this.$d.dialog(this)
      dialog.show({
        maximized: this.mobile,
        class: 'regrading-record--dialog',
        persistent: true,
        headerHidden: true,
        contentComponent: StockInventoryRegradingRecord,
        contentProps: {
          regradingRecordInput: JSON.parse(JSON.stringify(regradingRecord)),
          record: this.record,
          toolRecord: toolRecord,
          regradingRecords: this.regradingRecords,
          toolRecords: this.toolRecords
        },
        componentHandlers: {
          close: function () {
            dialog.hide()
          },
          save: (newRegradingRecord, newToolRecordB) => {
            const regradingRecord = this.regradingRecords.find(r => r.id === newRegradingRecord.id)
            regradingRecord.amountDiff = newRegradingRecord.amountDiff
            regradingRecord.amountDiffType = newRegradingRecord.amountDiffType
            regradingRecord.regradingType = newRegradingRecord.regradingType
            this.$set(regradingRecord, 'edited', true)

            const toolRecordA = this.toolRecords.find(tR => tR.id === toolRecord.id)
            if (toolRecordA != null) {
              toolRecordA.unit = toolRecord.unit
              toolRecordA.amountReal = toolRecord.amountReal
              toolRecordA.amountDiff = toolRecord.amountDiff
              toolRecordA.amountDiffType = toolRecord.amountDiffType
              toolRecordA.edited = true
            }

            if (this.toolRecord != null) {
              if (toolRecord.id === this.toolRecord.id) {
                this.toolRecord.unit = toolRecord.unit
                this.toolRecord.amountReal = toolRecord.amountReal
                this.toolRecord.amountDiff = toolRecord.amountDiff
                this.toolRecord.amountDiffType = toolRecord.amountDiffType
                this.toolRecord.edited = true
              } else if (newToolRecordB.id === this.toolRecord.id) {
                this.toolRecord.unit = newToolRecordB.unit
                this.toolRecord.amountReal = newToolRecordB.amountReal
                this.toolRecord.amountDiff = newToolRecordB.amountDiff
                this.toolRecord.amountDiffType = newToolRecordB.amountDiffType
                this.toolRecord.edited = true
              }
            }

            const toolRecordB = this.toolRecords.find(toolRecord => (toolRecord.tool && toolRecord.tool.uniqueKey) === (newRegradingRecord.toolB && newRegradingRecord.toolB.uniqueKey))
            if (toolRecordB != null) {
              toolRecordB.amountReal = newToolRecordB.amountReal
              toolRecordB.amountDiff = newToolRecordB.amountDiff
              toolRecordB.amountDiffType = newToolRecordB.amountDiffType
              toolRecordB.edited = true
            }

            dialog.hide()
          }
        }
      })
    },
    onAdd: function () {
      const toolRecord = JSON.parse(JSON.stringify(this.toolRecord))
      const dialog = this.$d.dialog(this)
      dialog.show({
        maximized: this.mobile,
        class: 'regrading-record--dialog',
        persistent: true,
        headerHidden: true,
        contentComponent: StockInventoryRegradingRecord,
        contentProps: {
          record: this.record,
          toolRecord: toolRecord,
          regradingRecords: this.regradingRecords,
          toolRecords: this.toolRecords
        },
        componentHandlers: {
          close: function () {
            dialog.hide()
          },
          save: (newRegradingRecord, newToolRecordB) => {
            newRegradingRecord.added = true
            newRegradingRecord.id = Date.now()

            const toolRecordB = this.toolRecords.find(toolRecord => (toolRecord.tool && toolRecord.tool.uniqueKey) === (newRegradingRecord.toolB && newRegradingRecord.toolB.uniqueKey))

            if (!toolRecordB) {
              const newToolBId = newRegradingRecord.id + 1

              this.toolRecords.push({
                id: newToolBId,
                tool: {
                  id: newRegradingRecord.toolB.id,
                  uniqueKey: newRegradingRecord.toolB.uniqueKey,
                  key: newRegradingRecord.toolB.key,
                  name: newRegradingRecord.toolB.name,
                  partyNumber: newRegradingRecord.toolB && newRegradingRecord.toolB.partyNumber,
                  partyName: newRegradingRecord.toolB && newRegradingRecord.toolB.partyName,
                  serialNumber: newRegradingRecord.toolB && newRegradingRecord.toolB.serialNumber,
                  serialKey: newRegradingRecord.toolB && newRegradingRecord.toolB.serialKey,
                  inventoryNumber: newRegradingRecord.toolB && newRegradingRecord.toolB.inventoryNumber
                },
                unit: newRegradingRecord.toolB.unit,
                amountReal: newToolRecordB.amountReal,
                added: true,
                deletable: true,
                additional: true
              })
              newRegradingRecord.toolBRecordId = newToolBId
            } else {
              newRegradingRecord.toolBRecordId = toolRecordB.id
              toolRecordB.amountReal = newToolRecordB.amountReal
              toolRecordB.amountDiff = newToolRecordB.amountDiff
              toolRecordB.amountDiffType = newToolRecordB.amountDiffType
              toolRecordB.edited = true
            }

            this.regradingRecords.push(newRegradingRecord)

            let toolRecordA
            if (this.toolRecord && this.toolRecord.id) {
              toolRecordA = this.toolRecords.find(toolRecord => toolRecord.id === this.toolRecord.id)
            }

            if (!toolRecordA) {
              const newToolAId = this.toolRecord && this.toolRecord.id ? this.toolRecord.id : (newRegradingRecord.id + 2)

              if (!(this.toolRecord && this.toolRecord.id)) {
                this.toolRecords.push(
                  {
                    id: newToolAId,
                    tool: {
                      id: this.toolRecord.tool && this.toolRecord.tool.id,
                      uniqueKey: this.toolRecord.tool && this.toolRecord.tool.uniqueKey,
                      key: this.toolRecord.tool && this.toolRecord.tool.key,
                      name: this.toolRecord.tool && this.toolRecord.tool.name,
                      partyNumber: this.toolRecord.tool && this.toolRecord.tool.partyNumber,
                      partyName: this.toolRecord.tool && this.toolRecord.tool.partyName,
                      serialNumber: this.toolRecord.tool && this.toolRecord.tool.serialNumber,
                      serialKey: this.toolRecord.tool && this.toolRecord.tool.serialKey,
                      inventoryNumber: this.toolRecord.tool && this.toolRecord.tool.inventoryNumber
                    },
                    unit: this.toolRecord.unit,
                    amountReal: this.toolRecord.amountReal,
                    photos: this.toolRecord.photos,
                    added: true,
                    deletable: true,
                    additional: true
                  })
              }
              newRegradingRecord.toolARecordId = newToolAId
            } else {
              newRegradingRecord.toolARecordId = this.toolRecord.id

              toolRecordA.amountReal = this.toolRecord.amountReal
              toolRecordA.amountDiff = this.toolRecord.amountDiff
              toolRecordA.photos = this.toolRecord.photos
              toolRecordA.amountDiffType = this.toolRecord.amountDiffType
              toolRecordA.unit = this.toolRecord.unit
              toolRecordA.edited = true
            }

            if (this.toolRecord != null) {
              this.toolRecord.unit = toolRecord.unit
              this.toolRecord.amountReal = toolRecord.amountReal
              this.toolRecord.amountDiff = toolRecord.amountDiff
              this.toolRecord.amountDiffType = toolRecord.amountDiffType
              this.toolRecord.edited = true
            }

            dialog.hide()
          }
        }
      })
    },
    onDelete: function (deletedRegradingRecord) {
      const index = this.regradingRecords.findIndex(r => r.id === deletedRegradingRecord.id)
      if (index !== -1) {
        // Удаление связанной номенклатуры при удалении пересортицы странно и оказалось не имеет смысла
        // const regradingRecord = this.regradingRecords[index]
        // const indexAdditionalRegardingTool = this.toolRecords.findIndex(toolRecord => toolRecord.additional && (toolRecord.id === regradingRecord.toolARecordId || toolRecord.id === regradingRecord.toolBRecordId))

        // if (indexAdditionalRegardingTool !== -1) {
        //   if (this.toolRecords[indexAdditionalRegardingTool].added) {
        //     this.toolRecords.splice(indexAdditionalRegardingTool, 1)
        //   } else {
        //     this.$set(this.toolRecords[indexAdditionalRegardingTool], 'removed', true)
        //   }
        // }

        if (this.regradingRecords[index].added) {
          this.regradingRecords.splice(index, 1)
        } else {
          this.$set(this.regradingRecords[index], 'removed', true)
        }
      }
    },
    getTrClass: function (row) {
      if (row._notValid) {
        return 'd-tr--red'
      } else if (row.deleted) {
        return 'd-tr--gray'
      } else if (row.added) {
        return 'd-tr--green'
      }
    },
    getColumns: function () {
      const columns = [
        // {
        //   name: 'id',
        //   label: 'id',
        //   defaultWidth: 90,
        //   sortable: true
        // },
        // {
        //   name: 'toolARecordId',
        //   label: 'toolARecordId',
        //   defaultWidth: 90,
        //   sortable: true
        // },
        // {
        //   name: 'toolBRecordId',
        //   label: 'toolBRecordId',
        //   defaultWidth: 90,
        //   sortable: true
        // },
        {
          name: 'toolA',
          label: 'Номенклатурная позиция A',
          field: 'toolA',
          format: value => value && formatUniqueToolName(value) || 'Неизвестная позиция',
          sortable: true
        },
        {
          name: 'toolB',
          label: 'Номенклатурная позиция B',
          field: 'toolB',
          format: value => value && formatUniqueToolName(value) || 'Неизвестная позиция',
          sortable: true
        },
        {
          name: 'amountDiff',
          label: 'Расхождение',
          labelTable: 'Расхождение',
          defaultWidth: 100,
          field: formatFieldDiffAmount,
          sortable: true
        },
        {
          name: 'regradingType',
          field: 'regradingType',
          label: 'Причина пересортицы',
          labelTable: 'Причина пересортицы',
          defaultWidth: 100,
          format: value => value && value.name,
          sortable: true
        }
      ]

      return this.prepareColumns(columns)
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
        if (column.sortable == null) {
          column.sortable = false
        }
      }
      return columns.filter(column => {
        return !this.mobile || !column.mobileHidden
      })
    }
  }
}

